export default "__VITE_ASSET__WZ30IoVm__"